export default __webpack_public_path__ + "img/0b34b61.svg";